import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {PermissionGroupProps} from '../types';
import permissionGroupsKeys from '../util/permission-groups-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useEditPermissionGroup = (groupId: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {invalidate} = useQueryHelpers();

  const onSuccess = (data: PermissionGroupProps) => {
    update(permissionGroupsKeys.list(), data);
    invalidate(permissionGroupsKeys.details(groupId));
  };

  return useApiMutation({
    url: `/permission-groups/${groupId}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar grupo de permissões',
    successTitle: 'Editar grupo de permissões',
    successMessage: 'Grupo de permissões atualizado com sucesso',
    onSuccess,
  });
};

export default useEditPermissionGroup;
